<template>
    <div>
        
        <h6 class="heading-small text-muted mb-4">LICENSE MANAGER</h6>
        
        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <base-alert v-if="messages != null" type="success">
            {{messages}}
        </base-alert>

        <form>
            <div class="row">
                <div class="col-lg-12">
                    <base-input alternative=""
                                label="System Name"
                                input-classes="form-control"
                                v-model="inputSystemName"
                                disabled
                               
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <base-input alternative=""
                                label="Terminal Name"
                                input-classes="form-control"
                                v-model="inputTerminalName"
                                disabled
                               
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <base-input alternative=""
                                label="Company Name"
                                input-classes="form-control"
                                v-model="inputCompanyName"
                                disabled
                               
                    />
                </div>
                <div class="col-lg-6">
                    <base-input alternative=""
                                label="Module Name"
                                input-classes="form-control"
                                v-model="inputModuleName"
                                disabled
                               
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-lg-6">
                    <!-- <base-input alternative=""
                                label="Expiration Date"
                                input-classes="form-control"
                                v-model="inputExpiration"
                               
                    /> -->
                    <base-input alternative="" label="Expiration Date">
                        <br>
                        <div>
                            <select v-model="expiryOption" @change="updateExpirationDate" class="text-uppercase form-control py-1" >
                                <option value="5 years">5 Years</option>
                                <option value="3 years">3 Years</option>
                                <option value="1 year">1 Year</option>
                                <option value="6 months">6 Months</option>
                                <option value="1 month">1 Month</option>
                                <option value="1 week">1 Week</option>
                                <option value="manual">Manual</option>
                            </select>
                            <br>
                            <a-date-picker v-if="expiryOption === 'manual'" v-model="inputExpiration" :format="dateFormat" input-classes="form-control" :disabled="expiryOption !== 'manual'"/>
                        </div>
                    </base-input>
                </div>
                <div class="col-lg-6">
                    <!-- <base-input alternative=""
                                label="Activated Date"
                                input-classes="form-control"
                                v-model="inputActivation"
                                disabled
                               
                    /> -->
                    <base-input alternative="" label="Activation Date">
                        <br><a-date-picker v-model="inputActivation" :format="dateFormat" input-classes="form-control" disabled/>
                    </base-input>
                </div>

                <div class="col-lg-6">
                  <label class="form-label d-block">BIR License Version</label>

                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="license-50"
                      value="5.0"
                      v-model="inputLicenseVersion"
                    />
                    <label class="form-check-label" for="license-50">5.0</label>
                  </div>
              
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="license-51"
                      value="5.1"
                      v-model="inputLicenseVersion"
                    />
                    <label class="form-check-label" for="license-51">5.1</label>
                  </div>
                </div>
            </div>
            <hr>
            <p v-if="expiryOption !== 'manual'" class="form-control-label">New Expiry Date: <span class="text-uppercase font-weight-normal">{{ currentExpiryDate }}</span></p>

            <hr class="my-4" />
            <h6 class="heading-small text-muted mb-4">License</h6>
            <div class="row">
                <div class="col-lg-12">
                    <base-input alternative=""
                                label="License Key"
                                input-classes="form-control"
                                v-model="inputLicenseKey"
                                disabled       
                    />
                </div>
            </div>

            <span class="account-type-container">
                            <div class="account-label-container">
                                Billing Type :
                            </div>
                            <a-select
                              v-model="selectedBillingType"
                              style="width: 65%"
                              @change="handleChange(accountId)">
                              <a-select-option  v-for="(billing_type, index) in billingTypes"
                                   :key="index"
                                   :value="billing_type.id">
                                  {{ billing_type.name }}
                              </a-select-option>
                            </a-select>
            </span>
        </form>

        <div style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
            <button v-if="inputLicenseKey == null" type="button" class="btn btn-success float-right" @click.prevent="generateLicenseKey">Generate License</button>
            <div v-else>
                <a-popconfirm title="Are you sure you want to revoke the license of this terminal?" @confirm="revokeLicenseKey" okText="Revoke" cancelText="Cancel">
                    <a class="btn btn-danger float-right text-white">Revoke License</a>
                </a-popconfirm>
                <a-popconfirm title="Are you sure you want to regenerate the license of this terminal?" @confirm="generateLicenseKey" okText="Regenerate" cancelText="Cancel">
                    <a class="btn btn-success float-right text-white mr-2">Regenerate License</a>
                </a-popconfirm>
            </div>
       </div> 

    </div>
</template>


<script>
import axios from "axios";
import HTTPRequest from '../../../controllers/httpRequest.js'
import { mapState } from 'vuex'
import secureStorage from '../../../controllers/secureStorage';
import moment from 'moment';

var component_x;
export default {
    computed: {
        ...mapState(['endPoint', 'profileId']),
        currentExpiryDate() {
        if (!this.inputExpiration) {
            return null;
        }
        const date = new Date(this.inputExpiration);
        return date.toLocaleDateString();
    }
    },
    data: function(){
        return {
            billingTypes:[],
            currentTerminalID:null,
            selectedBillingType:'',
            accountId: null,
            inputSystemName: "Barter XI",
            inputModuleName: "POS",
            inputCompanyName: "iRipple, Inc.",
            inputTerminalName: "",
            inputLicenseKey: null,
            inputActivation: "",
            inputLicenseVersion: "5.1",
            inputExpiration: "",
            dateFormat: 'MM-DD-YYYY',
            errors: [],
            messages: null,
            expiryOption: "manual",
        }
    },
     methods: {
        updateExpirationDate() {
        if (this.expiryOption === 'manual') {
            return;
        }

        let expirationDate;
        if (!this.inputExpiration) {
            expirationDate = new Date(); // Use today's date as the starting point
        } else {
            expirationDate = new Date(this.inputExpiration);
        }
        if (this.expiryOption === '1 year') {
            expirationDate.setFullYear(expirationDate.getFullYear() + 1);
        } else if (this.expiryOption === '2 years') {
            expirationDate.setFullYear(expirationDate.getFullYear() + 2);
        } else if (this.expiryOption === '3 years') {
            expirationDate.setFullYear(expirationDate.getFullYear() + 3);
        } else if (this.expiryOption === '5 years') {
            expirationDate.setFullYear(expirationDate.getFullYear() + 5);
        } else if (this.expiryOption === '6 months') {
            expirationDate.setMonth(expirationDate.getMonth() + 6);
        } else if (this.expiryOption === '1 month') {
            expirationDate.setMonth(expirationDate.getMonth() + 1);
        } else if (this.expiryOption === '1 week') {
            expirationDate.setDate(expirationDate.getDate() + 7);
        }
        expirationDate.setDate(expirationDate.getDate() - 1); 
        this.inputExpiration = expirationDate;
    },
        async getBillingTypes(){
          this.billingTypes = await HTTPRequest.getRequest(`${this.endPoint}/billing_types`, null, null) 
        },
        async handleChange(id){
          let params = { 'billing_type_id': this.selectedBillingType , 'account_id': this.accountId }
          await HTTPRequest.putRequest(`${this.endPoint}/terminals/${this.currentTerminalID}`, null, params) 
        },
        revokeLicenseKey(){
            axios({
            method: 'delete',
            url: this.endPoint + 'licenses/' + this.inputTerminalName  + "?field_name=terminal_code&account_id=" + this.accountId,
            headers: {
              Authorization: 'Bearer ' + secureStorage.getItem("accessToken"),
              "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
            },
          })
          .then(async function() {
            // console.log(data)
            var brand_data = await HTTPRequest.getRequest(component_x.endPoint + 'licenses/' + component_x.inputTerminalName  + "?field_name=terminal_code&account_id=" + component_x.accountId, null) 
            if(brand_data["error"] == undefined){
                component_x.inputLicenseKey = brand_data["license_key"]
            } else {
                component_x.inputExpiration = null
                component_x.inputLicenseKey = null
                component_x.messages = "Successfully revoked license"
                document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
            }
          })
          .catch(function(e) {
            alert(e)
          });
          
        },
        async generateLicenseKey(){
            var licensePayload = { license: {terminal_code: this.inputTerminalName, module: this.inputModuleName, company: this.inputCompanyName, expiry_date: this.inputExpiration, license_version: this.inputLicenseVersion}}
            var post_request = await HTTPRequest.postRequest(this.endPoint + 'licenses?account_id=' + this.accountId, null, licensePayload)   
            localStorage.setItem("expiryOption", this.expiryOption);
            if(post_request == undefined){
                // this.$router.go(-1)
            } else {
               if(post_request["error"] == undefined){
                   var brand_data = await HTTPRequest.getRequest(this.endPoint + 'licenses/' + this.inputTerminalName  + "?field_name=terminal_code&account_id=" + this.accountId, null) 
                   if(brand_data["error"] == undefined){
                    this.inputLicenseKey = brand_data["license_key"]
                    component_x.messages = "Successfully generated license"
                    component_x.errors = []
                    document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                   }  
                } else {
                    this.errors = []
                    this.errors.push(post_request["error"])
                    component_x.messages = null
                    document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                }
            } 

        }

    },

    mounted: async function(){
        component_x = this;
        this.accountId = this.$attrs.accountId
        this.inputTerminalName = ""
        this.getBillingTypes();
        var terminal_data = await HTTPRequest.getRequest(this.endPoint + 'terminals/' + this.profileId + "?account_id=" + this.accountId, null)
        this.selectedBillingType = terminal_data.billing_type_id === null ? '' : terminal_data.billing_type_id
        this.currentTerminalID = terminal_data.id
        var terminal_code = terminal_data["code"]
        this.inputTerminalName = terminal_code
        // console.log(terminal_data)
        const storedExpiryOption = localStorage.getItem("expiryOption");
        if (storedExpiryOption) {
            this.expiryOption = storedExpiryOption;
        }

        if(terminal_code != undefined){
            var brand_data = await HTTPRequest.getRequest(this.endPoint + 'licenses/' + terminal_code  + "?field_name=terminal_code&account_id=" + this.accountId, null)
            if(brand_data == undefined){
                this.inputLicenseKey = null
            } else {
                if(brand_data["error"] == undefined){
                    this.inputLicenseKey = brand_data["license_key"]
                    this.inputActivation = moment(brand_data["activation_date"])
                    this.inputLicenseVersion = String(
                      brand_data.license_version || '5.0'
                    )
                } else {
                    this.inputLicenseKey = null
                    // alert(brand_data["error"])
                    // component_x.$router.push("/")
                } 
            }
        }

    }
}
</script>

<style>
/* bryan */
.account-type-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.account-label-container{
  font-weight: bold;
  margin-right: 5px;
}
</style>
